import { peek, selector } from 'lib/selectors'
import { StateInterface } from 'types/state'

const guest = (state: StateInterface) => state.guest
export const jobsGuestSelector = selector(guest, peek('jobsList'))
export const jobsMetaGuestSelector = selector(guest, peek('jobsListMeta'))
export const jobsFavoriteSelector = selector(guest, peek('favoriteJobs'))
export const campaignsGuestSelector = selector(guest, peek('campaignsList'))
export const currentCampaignGuestSelector = selector(guest, peek('currentCampaign'))
